export const removeSuccessToast = {
  title: '已成功删除 $t(tracker:displayKind, {"context": "{{context}}" })',
};
